var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 5.00015L7.00001 3.00015M1.25 10.7502L2.94218 10.5621C3.14893 10.5392 3.2523 10.5277 3.34892 10.4964C3.43464 10.4686 3.51622 10.4294 3.59144 10.3798C3.67623 10.3239 3.74977 10.2504 3.89686 10.1033L10.5 3.50015C11.0523 2.94787 11.0523 2.05244 10.5 1.50015C9.94773 0.947867 9.0523 0.947866 8.50001 1.50015L1.89686 8.10329C1.74977 8.25038 1.67623 8.32392 1.62032 8.40871C1.57072 8.48393 1.53151 8.56551 1.50376 8.65123C1.47248 8.74785 1.46099 8.85122 1.43802 9.05797L1.25 10.7502Z",
    stroke: "#FF9900",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEdit);
export default __webpack_public_path__ + "static/media/menu-edit.1d8087e5d2ae76de151bf37240304e7d.svg";
export { ForwardRef as ReactComponent };